var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('homeCom',{attrs:{"active-value":_vm.active}}),_c('div',{staticClass:"scroll_area"},[_c('div',[_c('router-view',{on:{"menuChange":_vm.menuChange}})],1),_c('footerCom',{on:{"menuChange":_vm.menuChange}})],1),_c('el-backtop',{attrs:{"target":".scroll_area"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }